import FormText from 'components/form/FormText';
import type { UseFieldArrayReturn } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import type { DiagnosisEditFormStateType } from 'types/page/diagnosisEditFormStateType';

import type { JSX } from 'react';

/**
 * 診断作成編集 タイプ設定コンポーネント
 */
export default function WsDiagnosisEditResultOptions(props: {
  readOnly: boolean;
  fieldArray: UseFieldArrayReturn<DiagnosisEditFormStateType, 'results', 'id'>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext<DiagnosisEditFormStateType>();

  const { append, move, remove, fields } = props.fieldArray;

  // 登録可能最大件数
  const limit = 25;

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * オプションの順番を入れ替えます。
   */
  const onMove = (optionIndex: number, upper: boolean) => {
    // 先頭の場合は上に移動不可
    if (upper && optionIndex === 0) {
      return;
    }
    // 最終行の場合は下に移動不可
    if (!upper && optionIndex === fields.length - 1) {
      return;
    }
    // 要素の入れ替え
    move(optionIndex, upper ? optionIndex - 1 : optionIndex + 1);
  };

  /**
   * オプションを削除します。
   */
  const onRemove = (optionIndex: number) => {
    // ２件以下の場合は削除不可
    if (fields.length <= 2) {
      return;
    }
    // 要素の削除
    remove(optionIndex);
  };

  /**
   * オプションを追加します。
   */
  const onAppend = () => {
    const values = getValues();
    const results = values.results;

    // 上限値以上の場合は削除不可
    if (results.length >= limit) {
      return;
    }
    // 要素の追加
    append({ id: Math.random(), isNew: true });
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-form-default section-question" id="result-options">
        <div className="container">
          <div key={`ws-diagnosis-edit-result-options`} className="box-common mb-3">
            <h3 className="title-section">はじめに各タイプごとの診断結果を設定しよう</h3>

            <div className="form-default-container">
              <div className="row row-0">
                <div className="col-md col-form ps-md-5 ms-md-2">
                  <div className="form-group form-group-md">
                    <div className="row">
                      <div className="col">
                        <label htmlFor="option1" className="form-label">
                          タイプ分けの結果
                        </label>
                      </div>
                    </div>
                    {fields.map((field, resultIndex) => {
                      return (
                        <div key={field.id} className="form-group row align-items-center">
                          <div className="col-lg">
                            <div className="form-group-row">
                              <div className="col-2 d-table">
                                <label
                                  htmlFor="option1"
                                  className="form-label mb-lg d-table-cell align-middle text-center fs-6"
                                >
                                  タイプ
                                  {String.fromCharCode(65 + resultIndex)}
                                </label>
                              </div>
                              <div className="col">
                                <FormText
                                  name={`results.${resultIndex}.title`}
                                  placeholder={`例：${
                                    resultIndex % 3 === 0
                                      ? 'ライオン'
                                      : resultIndex % 3 === 1
                                        ? 'うさぎ'
                                        : '犬'
                                  }タイプ`}
                                  register={register}
                                  errors={errors}
                                  readOnly={props.readOnly}
                                  maxLength={50}
                                  className="form-control-md"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg col-btn d-flex flex-grow-0 ms-auto text-nowrap">
                            <div className="btn-group">
                              <button
                                className="btn"
                                onClick={() => onMove(resultIndex, true)}
                                disabled={props.readOnly || resultIndex === 0}
                              >
                                <img src="/img/icon/arrow-up-black.svg" alt="" />
                              </button>
                              <button
                                className="btn"
                                onClick={() => onMove(resultIndex, false)}
                                disabled={props.readOnly || resultIndex === fields.length - 1}
                              >
                                <img
                                  src="/img/icon/arrow-up-black.svg"
                                  alt=""
                                  className="scaley-1"
                                />
                              </button>
                              <button
                                onClick={() => onRemove(resultIndex)}
                                disabled={props.readOnly || fields.length <= 2}
                                className="btn"
                              >
                                <img src="/img/icon/trash.svg" alt="" className="filter-black" />
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="btn-container max-width-238 mx-auto">
                      <button
                        className="btn btn-common moderate-blue w-100"
                        onClick={onAppend}
                        disabled={fields.length >= limit || props.readOnly}
                      >
                        + 選択肢を追加
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
